export default __webpack_public_path__ + "static/media/Group.1adef338.svg";